// src/components/Main.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";

// Pages
import HomePage from "../pages/home/HomePage";
import ProfilesPage from "../pages/profiles/ProfilesPage";
import ProfileDetailPage from "../pages/profiles/profile-detail-page/ProfileDetailPage";
import ProfileInputForm from "../pages/profile-input/ProfileInputForm";
import AboutPage from "../pages/about/AboutPage";
import ContactUs from "../pages/contact/ContactUs";
// import BlogPage from "../pages/BlogPage";
// import FAQsPage from "../pages/FAQsPage";
import NotFound from "../pages/NotFound"; // create this page if not already

function Main() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />

      <Route path="/profiles" element={<ProfilesPage />} />
      <Route path="/profile/:id" element={<ProfileDetailPage />} />
      <Route path="/profile-input" element={<ProfileInputForm />} />

      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact-us" element={<ContactUs />} />

      {/* <Route path="/blog" element={<BlogPage />} /> */}
      {/* <Route path="/faqs" element={<FAQsPage />} /> */}

      {/* Fallback route – always keep this last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Main;
